import { render, staticRenderFns } from "./audienceTable.vue?vue&type=template&id=f94bb10a&scoped=true"
import script from "./audienceTable.vue?vue&type=script&lang=js"
export * from "./audienceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94bb10a",
  null
  
)

export default component.exports